// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2a388d29","732":"373a1ff3","977":"c81937e0"}[chunkId] + ".chunk.js";
};